<template>
    <div id="manager" >
        <div class="con">
            <img class="imgborder" src="../../assets/project/add-border.png" alt="">
            <div class="details" v-loading="loading" element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(1, 14, 36, 0.7)">
                <div class="close" @click="close">
                    <img src="../../assets/vehicleData/close.png" alt="">
                </div>
                <div class="title">
                    <img src="../../assets/project/project-left.png" alt="">
                    <span class="text">管理员管理</span>
                    <img src="../../assets/project/project-right.png" alt="">
                </div>
                <div class="line"><img src="../../assets/vehicleData/line.png" alt=""></div>
                <div class="content" >
                    <div class="content_top">
                        <div class="content_top_item">登录名</div>
                        <div class="content_top_item">
                            <el-input v-model="name" clearable placeholder="请输入登录名"></el-input>
                        </div>
                        <div class="content_top_item">用户级别</div>
                        <div class="content_top_item">
                            <el-select v-model="layer" placeholder="请选择用户级别" clearable>
                                <el-option
                                v-for="item in UserLevelData"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <div class="content_top_item button" @click="Search">
                            <div class="query_button">查询</div>
                        </div>
                        <div class="content_top_item button" @click="add">
                            <div class="add_button">添加</div>
                        </div>
                    </div>
                    <div class="content_list">
                        <el-table 
                        :data="tableData" 
                        style="width: 100%;" height="100%" 
                        :header-cell-style="{textAlign: 'center'}"
                        :row-class-name="tableRowClassName">
                            <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                            <el-table-column prop="name" label="用户名" align="center" :show-overflow-tooltip="true"> 
                            </el-table-column>
                            <el-table-column prop="loginName" label="登录名" align="center" :show-overflow-tooltip="true"> 
                            </el-table-column>
                            <el-table-column prop="layer" label="用户级别" align="center" width="80">
                            </el-table-column>
                            <el-table-column label="代理商" align="center" width="70">
                                <template slot-scope="scope">
                                    <div>
                                        {{scope.row.whetherAgent | whetherAgentFormat}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="区域" align="center" :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <div>
                                        {{scope.row.provinceName | provinceFormat}}{{scope.row.cityName | provinceFormat}}{{scope.row.areaName | provinceFormat}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" align="center" width="60">
                                <template slot-scope="scope">
                                    <el-dropdown>
                                        <span class="el-dropdown-link">
                                            <img src="../../assets/set/ellipsis.png" alt="">
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item @click.native="handleDetails(scope.row)">编辑</el-dropdown-item>
                                            <el-dropdown-item @click.native="handleDel(scope.row)">删除</el-dropdown-item>
                                            <el-dropdown-item  @click.native="handlChangePass(scope.row)">重置密码</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="content_pagination">
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"  :page-size="pageSize" background layout="prev, pager, next " :total="total" :page-count="pageCount" small>
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        width="33%"
        :close-on-click-modal="false"
        @open="handleOpen"
        :show-close="false"
        :modal="false"
        :center="true">
            <div class="close" @click="handleClose('ruleForm')"><img src="../../assets/vehicleData/close.png" alt=""></div>
            <div class="line"><img src="../../assets/vehicleData/line.png" alt=""></div>
            <div class="content">
                <el-form ref="ruleForm" :model="ruleForm" :rules="rules">
                    <div style="display:flex;justify-content: space-between;">
                        <el-form-item prop="name" label="管理员名称" style="width: 48%">
                            <el-input v-model="ruleForm.name" clearable maxlength="30" show-word-limit placeholder="请输入管理员名称"></el-input>
                        </el-form-item>
                        <el-form-item label="标题" style="width: 48%">
                            <el-input v-model="ruleForm.title" clearable maxlength="30" show-word-limit placeholder="请输入标题"></el-input>
                        </el-form-item>
                    </div>
                    <div style="display:flex;justify-content: space-between;">
                        <el-form-item prop="loginName" label="登录名" style="width: 48%">
                            <el-input v-model="ruleForm.loginName" clearable maxlength="30" show-word-limit placeholder="请输入登录名"></el-input>
                        </el-form-item>
                        <el-form-item label="密码" style="width: 48%">
                            <el-input v-model="ruleForm.password" clearable maxlength="30" show-word-limit placeholder="请输入密码"></el-input>
                        </el-form-item>
                    </div>
                    <div style="display:flex;justify-content: space-between;">
                        <el-form-item prop="roleId" label="用户角色" style="width: 48%" v-if="userLayer == 'admin'">
                            <el-select style="width:100%" v-model="ruleForm.roleId" placeholder="请选择用户角色" multiple clearable>
                                <el-option v-for="item in UserRoleData" :key="item.roleId" :label="item.roleName" :value="item.roleId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="layer" label="用户级别" style="width: 48%">
                            <el-select style="width:100%" v-model="ruleForm.layer" placeholder="请选择用户级别"  clearable @change="layerChange">
                                <el-option v-for="item in UserLevelData" :key="item.code" :label="item.name" :value="item.code">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <el-form-item  v-show="userState==1" label="是否是代理商管理员">
                        <el-select style="width:100%" v-model="ruleForm.whetherAgent" placeholder="请选择是否是代理商管理员" clearable>
                            <el-option v-for="item in whetherData" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="合作社级别" v-show="ruleForm.layer=='合作社'">
                        <el-select style="width:100%" v-model="ruleForm.cooperativeLevel" placeholder="请选择合作社级别" clearable>
                            <el-option v-for="item in HeZuoSheLevelData" :key="item.code" :label="item.name" :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-show="userState==1" label="是否是总管理员">
                        <el-select style="width:100%" v-model="ruleForm.isTotalAdministrator" placeholder="请选择合作社级别" clearable>
                            <el-option v-for="item in whetherData" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属区域">
                        <el-select style="width:100%" v-model="ruleForm.provinceId" placeholder="请选择所属省" @change="provinceIdChange" clearable :disabled="proviceDisabled">
                            <el-option v-for="item in provinceIdData" :key="item.areaCode" :label="item.areaName" :value="item.areaCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-show="ruleForm.layer=='市'||ruleForm.layer=='县'||ruleForm.layer=='合作社'">
                        <el-select style="width:100%" v-model="ruleForm.cityId" placeholder="请选择所属市" @change="cityIdChange" clearable :disabled="cityDisabled">
                            <el-option v-for="item in cityIdData" :key="item.areaCode" :label="item.areaName" :value="item.areaCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-show="ruleForm.layer=='县'||ruleForm.layer=='合作社'">
                        <el-select style="width:100%" v-model="ruleForm.areaId" placeholder="请选择所属县" @change="areaIdChange" clearable :disabled="areaDisabled">
                            <el-option v-for="item in areaIdData" :key="item.areaCode" :label="item.areaName" :value="item.areaCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="选择下级" v-if="(ruleForm.layer=='省'||ruleForm.layer=='市'||ruleForm.layer=='县')&&ruleForm.isTotalAdministrator==0" >
                        <el-checkbox-group v-model="ruleForm.areaIdsName" style="width:100%" @change="changeVal">
                            <el-checkbox style="width:100%" v-for="item in areasData" :key="item.areaCode" :label="item.areaName" :value="item.areaCode"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="作业类型">
                        <el-select style="width:100%" v-model="ruleForm.moduleIds" placeholder="请选择作业类型" multiple clearable>
                            <el-option v-for="item in moduleData" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="位置" prop="location" v-show="ruleForm.layer!='合作社'">
                        <el-input v-model="ruleForm.location" placeholder="请选择位置" disabled></el-input>
                    </el-form-item>
                    <div class="mapdiv" v-show="ruleForm.layer!='合作社'">
                        <div id="mapdiv" class="mapdiv"></div>
                    </div>
                    <el-form-item label="功能区域" v-show="ruleForm.layer=='合作社'">
                        <div class="function_list">
                            <div class="list_item" @click="check(1)">
                                <span v-show="checkIndex==1">*</span>
                                合作社边界
                            </div>
                            <div class="list_item" @click="check(2)">
                                <span v-show="checkIndex==2">*</span>
                                车库
                            </div>
                            <div class="list_item" @click="check(3)">
                                <span v-show="checkIndex==3">*</span>
                                仓库
                            </div>
                            <div class="list_item" @click="check(4)">
                                <span v-show="checkIndex==4">*</span>
                                授课区域
                            </div>
                            <div class="list_item" @click="check(5)">
                                <span v-show="checkIndex==5">*</span>
                                食堂
                            </div>
                            <div class="list_item button determine" @click="clearBorder">清除</div>
                        </div>
                    </el-form-item>
                    <div class="map" v-show="ruleForm.layer=='合作社'">
                        <div id="map" class="map"></div>
                    </div>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <div class="button cancel" @click="resetForm('ruleForm')">取消</div>
                <div class="button determine" @click="submitForm('ruleForm')">提交</div>
            </div>
        </el-dialog>
        
        <el-dialog
        title="提示"
        :visible.sync="delDialog"
        width="15%"
        :close-on-click-modal="false"
        :show-close="false"
        :modal="false"
        :center="true">
            <div class="close" @click="delDialog=false"><img src="../../assets/vehicleData/close.png" alt=""></div>
            <div class="line"><img src="../../assets/cooperative/line.png" alt=""></div>
            <div class="tips"><img src="../../assets/set/tips.png" alt=""></div>
            <div class="text">
                <!-- 此操作将永远删除此条数据,是否继续? -->
                {{text}}
            </div>
            <div slot="footer" class="dialog-footer">
                <div class="button cancel" @click="resetFormDel">取消</div>
                <div class="button determine" @click="submitFormDel">提交</div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import AdministratorService from '../../services/jaxrs/concrete/com.zny.eop.witAgriculture.api.AdministratorService.js';
import RoleManagementService from '../../services/jaxrs/concrete/com.zny.eop.platform.api.RoleManagementService.js';
import T from 'T'
export default {
    data(){
        return{
            loading:false,
            userState:localStorage.getItem('userState'),
            userLayer: localStorage.getItem('layer'),
            name:"",
            layer:"",
            UserLevelData:[],//用户级别数组
            UserRoleData:[],//用户角色数组
            tableData:[],
            dialogVisible:false,
            map:"",
            mapdiv:"",
            title:"",
            HeZuoSheLevelData:[//合作社级别
                {code:1,name:"国家"},
                {code:2,name:"省"},
                {code:3,name:"市"},
                {code:4,name:"县"},
            ],
            whetherData:[
                {label:"是",value:1},
                {label:"否",value:0},
            ],
            moduleData:this.$store.state.modulesType,
            provinceIdData:[],
            proviceDisabled:false,
            cityIdData:[],
            cityDisabled:false,
            areaIdData:[],
            areaDisabled:false,
            areasData:[],//下级数组
            checkIndex:1,
            borderData:[],//区域边框数组
            ruleForm:{
                userId:"",
                name:"",
                loginName:"",
                title:"",
                password:"",
                whetherAgent:0,
                roleId:"",
                layer:"",
                cooperativeLevel:"",
                isTotalAdministrator:"",
                provinceId:"",
                provinceName:"",
                cityId:"",
                cityName:"",
                areaId:"",
                areaName:"",
                areaIds:[],
                areaIdsName:[],
                moduleIds:"",
                location:"",
                mapCenterLat:"",
                mapCenterLng:"",
                cooperativeAreaPo:{
                    cooperativeBorder:"",
                    diningRoomBorder:"",
                    diningRoomCenter:"",
                    garageBorder:"",
                    garageCenter:"",
                    teachingBorder:"",
                    teachingCenter:"",
                    warehouseBorder:"",
                    warehouseCenter:""
                }
            },
            rules:{
                name: [
                    { required: true, message: '请输入用户名', trigger: 'blur' },
                ],
                loginName: [
                    { required: true, message: '请输入登录名', trigger: 'blur' },
                ],
                title: [
                    { required: true, message: '请输入标题', trigger: 'blur' },
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                ],
                whetherAgent: [
                    { required: true, message: '请选择是否为代理商管理员', trigger: 'change' },
                ],
                roleId: [
                    { required: true, message: '请选择用户角色', trigger: 'change' },
                ],
                layer: [
                    { required: true, message: '请选择用户级别', trigger: 'change' },
                ],
                isTotalAdministrator: [
                    { required: true, message: '请选择是否为管理员', trigger: 'change' }
                ],
                region: [
                    { required: true, message: '请选择所属区域', trigger: 'change' }
                ],
                areaIdsName: [
                    { required: true, message: '请选择下级', trigger: 'change' },
                ],
                address: [
                    { required: true, message: '请选择位置', trigger: 'blur' },
                ],
            },
            delDialog:false,
            isDel:1,//1:删除，0：重置密码
            text:"",
            delId:"",
            // 分页
            pageFlag:0,
            currentPage:1,
            pageSize:20,
            total:1,
            pageCount:1,
        }
    },
    filters: {
        whetherAgentFormat(msg) {
            if(msg==0){
                return "否"
            }else{
                return '是'
            }
        },
        provinceFormat(msg) {
            if(msg==0){
                return ""
            }else{
                return msg
            }
        },
    },
    mounted(){
        this.onload();
        this.forList();
        this.forUserLevelInfo();
    },
    methods:{
        onload(){
            // console.log(this)
        },
        forList(){
            this.loading=true
            var poPageRequest={
                num:this.currentPage,
                pageSize:this.pageSize,
                condition:{
                    loginName:this.name,
                    layer:this.layer,
                }
            }
            AdministratorService.administratorInfoList(poPageRequest)
            .then((res)=>{
                // console.log(res)
                var that=this
                that.tableData=res.list
                that.total=res.totalNum
                that.pageCount=res.totalPage
                that.loading=false
            }).catch(()=>{
                this.loading=false
            })
        },
        // 获取用户级别
        forUserLevelInfo(){
            AdministratorService.userLevelInfo()
            .then((res)=>{
                // console.log(res)
                var that=this
                that.UserLevelData=res
            })
        },
        // 获取角色
        forRole(){
            RoleManagementService.roleInfoListByCurrentUser()
            .then((res)=>{
                // console.log(res)
                var that=this
                that.UserRoleData=res
            })
        },
        // 查询
        Search(){
            this.currentPage=1;
            this.forList();
        },
        // 添加
        add(){
            this.dialogVisible=true
            this.title="添加"
        },
        // 编辑
        handleDetails(row){
            // console.log(row)
            this.dialogVisible=true
            this.title="编辑"
            AdministratorService.administratorInfoByUserId(row.userId)
            .then((res)=>{
                // console.log(res)
                var that=this
                that.ruleForm.userId=res.userId
                that.ruleForm.name=res.name
                that.ruleForm.loginName=res.loginName
                that.ruleForm.password=res.password
                that.ruleForm.whetherAgent=res.whetherAgent
                that.ruleForm.roleId=res.roleId==''?'':res.roleId.split(',').map(Number)
                that.ruleForm.layer=res.layer
                that.ruleForm.cooperativeLevel=res.cooperativeLevel
                that.ruleForm.isTotalAdministrator=res.isTotalAdministrator
                that.ruleForm.provinceId=res.provinceId==null?"":res.provinceId.toString()
                that.ruleForm.provinceName=res.provinceName==""?"":res.provinceName
                that.ruleForm.cityId=res.cityId==null?"":res.cityId.toString()
                that.ruleForm.cityName=res.cityName==""?"":res.cityName
                that.ruleForm.areaId=res.areaId==null?"":res.areaId.toString()
                that.ruleForm.areaName=res.areaName==""?"":res.areaName
                that.getcityIdData()
                that.getareaIdData()
                that.getlowerLevelData()
                that.ruleForm.areaIds=res.areaIds==''?'':res.areaIds.split(',')
                that.ruleForm.moduleIds=res.moduleIds==''?'':res.moduleIds.split(',').map(Number)
                that.ruleForm.cooperativeAreaPo=res.cooperativeAreaPo
                setTimeout(function(){
                    var areaIdsName=[]
                    for(var i=0;i<that.ruleForm.areaIds.length;i++){
                        for(var j=0;j<that.areasData.length;j++){
                            if(that.ruleForm.areaIds[i]==that.areasData[j].areaCode){
                                areaIdsName.push(that.areasData[j].areaName)
                            }
                        }
                    }
                    that.ruleForm.areaIdsName=areaIdsName
                    if(res.layer=="合作社"){
                        that.loadmap()
                        that.forCooperativeBorder()
                        that.forDiningRoomBorder()
                        that.forGarageBorder()
                        that.forTeachingBorder()
                        that.forWarehouseBorder()
                        that.forpolygonTool()
                    }else{
                        var T = require('T');
                        if(that.mapdiv==''||that.mapdiv==undefined){
                            that.mapdiv = new T.Map("mapdiv");
                        }
                        that.ruleForm.mapCenterLng=res.mapCenterLng
                        that.ruleForm.mapCenterLat=res.mapCenterLat
                        // 根据经纬度解析地址
                        var lnglat=new T.LngLat(res.mapCenterLng,res.mapCenterLat)
                        var geocode = new T.Geocoder();
                        geocode.getLocation(lnglat,that.searchResult);
                        //创建标注对象
                        var marker = new T.Marker(new T.LngLat(res.mapCenterLng, res.mapCenterLat));
                        //向地图上添加标注
                        that.mapdiv.addOverLay(marker);
                        that.mapdiv.centerAndZoom(new T.LngLat(res.mapCenterLng, res.mapCenterLat), 18);
                    }
                },1000)
                
            })
        },
        // 合作社区域边框 编辑时显示
        forCooperativeBorder(){
            var arr=this.ruleForm.cooperativeAreaPo.cooperativeBorder.split(';')
            var points = [];
            for(var i=0;i<arr.length;i++){
                points.push(new T.LngLat(arr[i].split(",")[0], arr[i].split(",")[1]));
            }
            //创建面对象
            var polygon = new T.Polygon(points, {
                color: "#00EAFF",
                weight: 1,
                opacity: 1,
                fillColor: "transparent",
                fillOpacity: 0
            });
            polygon.id=1
            this.borderData.push(polygon)
            //向地图上添加面
            this.map.addOverLay(polygon);
        },
        // 合作社食堂区域边框 编辑时显示
        forDiningRoomBorder(){
            var arr=this.ruleForm.cooperativeAreaPo.diningRoomBorder.split(';')
            var points = [];
            for(var i=0;i<arr.length;i++){
                points.push(new T.LngLat(arr[i].split(",")[0], arr[i].split(",")[1]));
            }
            //创建面对象
            var polygon = new T.Polygon(points, {
                color: "#ff7901",
                weight: 1,
                opacity: 1,
                fillColor: "transparent",
                fillOpacity: 0
            });
            polygon.id=5
            this.borderData.push(polygon)
            //向地图上添加面
            this.map.addOverLay(polygon);
        },
        // 合作社车库区域边框 编辑时显示
        forGarageBorder(){
            var arr=this.ruleForm.cooperativeAreaPo.garageBorder.split(';')
            var points = [];
            for(var i=0;i<arr.length;i++){
                points.push(new T.LngLat(arr[i].split(",")[0], arr[i].split(",")[1]));
            }
            //创建面对象
            var polygon = new T.Polygon(points, {
                color: "#ff3f00",
                weight: 1,
                opacity: 1,
                fillColor: "transparent",
                fillOpacity: 0
            });
            polygon.id=2
            this.borderData.push(polygon)
            //向地图上添加面
            this.map.addOverLay(polygon);
        },
        // 合作社授课区域边框 编辑时显示
        forTeachingBorder(){
            var arr=this.ruleForm.cooperativeAreaPo.teachingBorder.split(';')
            var points = [];
            for(var i=0;i<arr.length;i++){
                points.push(new T.LngLat(arr[i].split(",")[0], arr[i].split(",")[1]));
            }
            //创建面对象
            var polygon = new T.Polygon(points, {
                color: "#007eff",
                weight: 1,
                opacity: 1,
                fillColor: "transparent",
                fillOpacity: 0
            });
            polygon.id=4
            this.borderData.push(polygon)
            //向地图上添加面
            this.map.addOverLay(polygon);
        },
         // 合作社仓库区域边框 编辑时显示
        forWarehouseBorder(){
            var arr=this.ruleForm.cooperativeAreaPo.warehouseBorder.split(';')
            var points = [];
            for(var i=0;i<arr.length;i++){
                points.push(new T.LngLat(arr[i].split(",")[0], arr[i].split(",")[1]));
            }
            //创建面对象
            var polygon = new T.Polygon(points, {
                color: "#eaff00",
                weight: 1,
                opacity: 1,
                fillColor: "transparent",
                fillOpacity: 0
            });
            polygon.id=3
            this.borderData.push(polygon)
            //向地图上添加面
            this.map.addOverLay(polygon);
        },
        // 删除
        handleDel(row){
            // console.log(row)
            this.delDialog=true
            this.delId=row.userId
            this.isDel=1
            this.text='此操作将永远删除此条数据,是否继续?'
        },
        // 修改密码
        handlChangePass(row){
            // console.log(row)
            this.delDialog=true
            this.delId=row.userId
            this.isDel=0
            this.text='此操作将恢复为初始密码,是否继续?'
        },
        // 设置表格斑马纹颜色
        tableRowClassName({ row, rowIndex }) {
            if ((rowIndex + 1) % 2 === 0) {
                return "statistics-warning-row";
            } else {
                return "";
            }
        },
        // 弹窗打开时触发
        handleOpen(){
            var that=this
            that.getprovinceIdData()
            that.forRole();
            setTimeout(function(){
                // that.loadmap()
                that.loadmapDiv()
            },100)
        },
        // 其他管理员地图
        loadmapDiv(){
            // var T = require('T');
            if(this.mapdiv==''||this.mapdiv==undefined){
                this.mapdiv = new T.Map("mapdiv");
            }
            //设置显示地图的中心点和级别
            this.mapdiv.centerAndZoom(new T.LngLat(localStorage.getItem("mapCenterLng"), localStorage.getItem("mapCenterLat")), 12);
            this.mapdiv.setMapType(TMAP_HYBRID_MAP);
            this.mapdiv.setMinZoom(4);
            this.mapdiv.setMaxZoom(18);
            var cp = new T.CoordinatePickup(this.mapdiv, {callback: this.getLngLat})
            cp.addEvent();
        },
        // 获取经纬度坐标
        getLngLat(lnglat) {
            // console.log(lnglat.lat,lnglat.lng)
            this.ruleForm.mapCenterLng=lnglat.lng
            this.ruleForm.mapCenterLat=lnglat.lat
            this.mapdiv.clearOverLays();
             //创建标注对象
            var marker = new T.Marker(new T.LngLat(lnglat.lng, lnglat.lat));
            //向地图上添加标注
            this.mapdiv.addOverLay(marker);

            //创建对象
            var geocode = new T.Geocoder();
            geocode.getLocation(lnglat,this.searchResult);
        },
        // 解析地址
        searchResult(result){
            // console.log(result)
            this.ruleForm.location=result.formatted_address
        },
        // 合作社地图
        loadmap(){
            // var T = require('T');
            if(this.map==''||this.map==undefined){
                this.map = new T.Map("map");
            }
            this.map.centerAndZoom(new T.LngLat(localStorage.getItem("mapCenterLng"), localStorage.getItem("mapCenterLat")), 12);
            this.map.setMapType(TMAP_HYBRID_MAP);
            this.map.setMinZoom(4);
            this.map.setMaxZoom(18);
        },
        // 选择用户级别时
        layerChange(){
            var that=this
            setTimeout(function(){
                that.loadmap()
                that.forpolygonTool()
            },1000)
        },
        // 功能区域点击选择
        check(num){
            this.checkIndex=num
            this.forpolygonTool()
        },
        // 选择区域
        forpolygonTool(){
            var color=""
            if(this.checkIndex==1){
                color="#00eaff"
            }else if(this.checkIndex==2){
                color="#ff3f00"
            }else if(this.checkIndex==3){
                color="#eaff00"
            }else if(this.checkIndex==4){
                color="#007eff"
            }else if(this.checkIndex==5){
                color="#ff7901"
            }
            var config = {
                showLabel: false,
                color: color, weight: 1, opacity: 1, fillColor: "transparent", fillOpacity: 0
            };
            //创建标注工具对象
            var polygonTool = new T.PolygonTool(this.map, config);
            polygonTool.open();
            polygonTool.addEventListener("draw",this.getPoints);
        },
        // 获取经纬度
        getPoints(e){
            e.currentPolygon.id=this.checkIndex
            // console.log(e,e.currentLnglats)
            this.borderData.push(e.currentPolygon)
            // console.log(this.borderData)
            var lnglat=''
            for(var i=0;i<e.currentLnglats.length;i++){
                lnglat+=e.currentLnglats[i].lng+','
                lnglat+=e.currentLnglats[i].lat+';'
            }
            if(this.checkIndex==1){
                this.ruleForm.cooperativeAreaPo.cooperativeBorder=lnglat.substring(0,lnglat.length-1)
            }else if(this.checkIndex==2){
                this.ruleForm.cooperativeAreaPo.garageBorder=lnglat.substring(0,lnglat.length-1)
            }else if(this.checkIndex==3){
                this.ruleForm.cooperativeAreaPo.warehouseBorder=lnglat.substring(0,lnglat.length-1)
            }else if(this.checkIndex==4){
                this.ruleForm.cooperativeAreaPo.teachingBorder=lnglat.substring(0,lnglat.length-1)
            }else if(this.checkIndex==5){
                this.ruleForm.cooperativeAreaPo.diningRoomBorder=lnglat.substring(0,lnglat.length-1)
            }
        },
        // 清除边框
        clearBorder(){
            if(this.checkIndex==1){
                this.ruleForm.cooperativeAreaPo.cooperativeBorder=''
            }else if(this.checkIndex==2){
                this.ruleForm.cooperativeAreaPo.garageBorder=''
            }else if(this.checkIndex==3){
                this.ruleForm.cooperativeAreaPo.warehouseBorder=''
            }else if(this.checkIndex==4){
                this.ruleForm.cooperativeAreaPo.teachingBorder=''
            }else if(this.checkIndex==5){
                this.ruleForm.cooperativeAreaPo.diningRoomBorder=''
            }
            for(var i=0;i<this.borderData.length;i++){
                if(this.borderData[i].id==this.checkIndex){
                    this.map.removeOverLay(this.borderData[i])
                }
            }
            this.forpolygonTool()
        },
        // 关闭弹窗
        handleClose(formName){
            if(this.ruleForm.layer=='合作社'){
                this.map.clearOverLays()
            }else{
                this.mapdiv.clearOverLays()
            }
            this.$refs[formName].resetFields();
            this.ruleForm.title=''
            this.ruleForm.password=''
            this.ruleForm.moduleIds=''
            this.ruleForm.provinceId=''
            this.dialogVisible=false
        },
        // 弹窗取消
        resetForm(formName) {
            if(this.ruleForm.layer=='合作社'){
                this.map.clearOverLays()
            }else{
                this.mapdiv.clearOverLays()
            }
            this.$refs[formName].resetFields();
            this.ruleForm.title=''
            this.ruleForm.password=''
            this.ruleForm.moduleIds=''
            this.ruleForm.provinceId=''
            this.dialogVisible=false
        },
        // 弹窗提交
        submitForm(formName) {
            var that=this
            that.$refs[formName].validate((valid) => {
                if(that.ruleForm.cooperativeAreaPo.cooperativeBorder==''&&that.ruleForm.layer=='合作社'){
                    that.$message.warning('请绘制合作社边界！')
                }else{
                    if (valid) {
                        var addUserInfoPo={}
                        if(that.title=='添加'){
                            addUserInfoPo={
                                name:that.ruleForm.name,
                                loginName:that.ruleForm.loginName,
                                title:that.ruleForm.title==''?"中农云智慧农机云平台":that.ruleForm.title,
                                password:that.ruleForm.password,
                                whetherAgent:that.ruleForm.whetherAgent,
                                roleId:that.ruleForm.roleId.toString(),
                                layer:that.ruleForm.layer,
                                cooperativeLevel:that.ruleForm.cooperativeLevel,
                                isTotalAdministrator:that.ruleForm.isTotalAdministrator,
                                provinceId:that.ruleForm.provinceId,
                                provinceName:that.ruleForm.provinceName,
                                cityId:that.ruleForm.cityId,
                                cityName:that.ruleForm.cityName,
                                areaId:that.ruleForm.areaId,
                                areaName:that.ruleForm.areaName,
                                areaIds:that.ruleForm.areaIds.toString(),
                                moduleIds:that.ruleForm.moduleIds.toString(),
                                location:that.ruleForm.location,
                                mapCenterLat:that.ruleForm.mapCenterLat,
                                mapCenterLng:that.ruleForm.mapCenterLng,
                                cooperativeAreaPo:that.ruleForm.cooperativeAreaPo
                            }
                            AdministratorService.addAdminInfo(addUserInfoPo)
                                .then((res)=>{
                                    // console.log(res)
                                    if(res){
                                        that.$message({
                                            type: 'success',
                                            message: "提交成功!"
                                        });
                                        that.$refs[formName].resetFields();
                                        if(that.ruleForm.layer=='合作社'){
                                            that.map.clearOverLays()
                                        }else{
                                            that.mapdiv.clearOverLays()
                                        }
                                        that.dialogVisible=false
                                        that.forList()
                                    }else{
                                        that.$message.error("操作失败!");
                                    }

                                })
                        }else if(that.title=='编辑'){
                            addUserInfoPo={
                                userId:that.ruleForm.userId,
                                name:that.ruleForm.name,
                                loginName:that.ruleForm.loginName,
                                title:that.ruleForm.title==''?"中农云智慧农机云平台":that.ruleForm.title,
                                password:that.ruleForm.password,
                                whetherAgent:that.ruleForm.whetherAgent,
                                roleId:that.ruleForm.roleId.toString(),
                                layer:that.ruleForm.layer,
                                cooperativeLevel:that.ruleForm.cooperativeLevel,
                                isTotalAdministrator:that.ruleForm.isTotalAdministrator,
                                provinceId:that.ruleForm.provinceId,
                                provinceName:that.ruleForm.provinceName,
                                cityId:that.ruleForm.cityId,
                                cityName:that.ruleForm.cityName,
                                areaId:that.ruleForm.areaId,
                                areaName:that.ruleForm.areaName,
                                areaIds:that.ruleForm.areaIds.toString(),
                                moduleIds:that.ruleForm.moduleIds.toString(),
                                location:that.ruleForm.location,
                                mapCenterLat:that.ruleForm.mapCenterLat,
                                mapCenterLng:that.ruleForm.mapCenterLng,
                                cooperativeAreaPo:that.ruleForm.cooperativeAreaPo
                            }
                            AdministratorService.changeAdminInfo(addUserInfoPo)
                            .then((res)=>{
                                    // console.log(res)
                                if(res){
                                    that.$message({
                                        type: 'success',
                                        message: "提交成功!"
                                    });
                                    that.$refs[formName].resetFields();
                                    if(that.ruleForm.layer=='合作社'){
                                        that.map.clearOverLays()
                                    }else{
                                        that.mapdiv.clearOverLays()
                                    }
                                    that.ruleForm.title=''
                                    that.ruleForm.password=''
                                    that.dialogVisible=false
                                    that.forList()
                                }else{
                                    that.$message.error("操作失败!");
                                }
                            })
                        }
                    }
                }
            })
        },
        getprovinceIdData(){
            var getAreaInfoPo={}
            if(localStorage.getItem('layer')=='admin'){
                getAreaInfoPo={
                    provinceId:localStorage.getItem('provinceId'),//省id
                    cityId:localStorage.getItem('cityId'),//市id
                    areaId:localStorage.getItem('areaId'),
                    checkId: undefined != this.checkid ? this.checkid : 0
                }
            }else if(localStorage.getItem('layer')=='省'||localStorage.getItem('layer')=='市'||localStorage.getItem('layer')=='县'){
                getAreaInfoPo={
                    provinceId:0,
                    cityId:0,
                    areaId:0,
                    checkId : undefined != this.checkid ? this.checkid : 0
                }
                this.proviceDisabled=false
                if(this.title=='添加'){
                    this.proviceDisabled=true
                    this.ruleForm.provinceId=localStorage.getItem('provinceId')
                    this.ruleForm.provinceName=localStorage.getItem('provinceName')
                    this.getcityIdData()
                }
            }
            AdministratorService.AreaInfoList(getAreaInfoPo)
            .then((response)=>{
                // console.log(response);
                this.provinceIdData=response
            })
        },
        provinceIdChange(val){
            for(var i=0;i<this.provinceIdData.length;i++){
                if(this.provinceIdData[i].areaCode==val){
                    this.ruleForm.provinceName=this.provinceIdData[i].areaName
                }
            }
            this.ruleForm.cityId=""
            this.ruleForm.areaId=""
            if(this.ruleForm.layer=="省"){
                this.getlowerLevelData();
            }else if(this.ruleForm.layer=="市" || this.ruleForm.layer== "县" || this.ruleForm.layer=="合作社"){
                this.getcityIdData()
            }
        },
        getcityIdData(){
            var getAreaInfoPo={}
            var id;
            if(localStorage.getItem('layer')=='admin'){
                id=this.ruleForm.provinceId.toString()==''?'0':this.ruleForm.provinceId.toString()
                getAreaInfoPo={
                    provinceId:localStorage.getItem('provinceId'),//省id
                    cityId:localStorage.getItem('cityId'),//市id
                    areaId:localStorage.getItem('areaId'),
                    checkId : id != undefined ? id : ''
                }
            }else if(localStorage.getItem('layer')=='省'){
                id=this.ruleForm.provinceId.toString()==''?'0':this.ruleForm.provinceId.toString()
                getAreaInfoPo={
                    provinceId:'0',
                    cityId:localStorage.getItem('cityId'),
                    areaId:localStorage.getItem('areaId'),
                    checkId : id != undefined ? id : ''
                }
                this.ruleForm.provinceId=localStorage.getItem('provinceId')
            }else if(localStorage.getItem('layer')=='市'||localStorage.getItem('layer')=='县'){
                getAreaInfoPo={
                    provinceId:'0',
                    cityId:'0',
                    areaId:'0',
                    checkId : localStorage.getItem("provinceId")
                }
                this.cityDisabled=false
                if(this.title=='添加'){
                    this.cityDisabled=true
                    this.ruleForm.cityId=localStorage.getItem('cityId')
                    this.ruleForm.cityName=localStorage.getItem('cityName')
                    this.getareaIdData()
                }
            }
            // else if(localStorage.getItem('layer')=='县'){
            //     getAreaInfoPo={
            //         provinceId:'0',
            //         cityId:'0',
            //         areaId:'0',
            //         checkId : localStorage.getItem("cityId")
            //     }
            // }
            AdministratorService.AreaInfoList(getAreaInfoPo)
            .then((response)=>{
                // console.log(response);
                this.cityIdData=response
            })
        },
        cityIdChange(val){
            for(var i=0;i<this.cityIdData.length;i++){
                if(this.cityIdData[i].areaCode==val){
                    this.ruleForm.cityName=this.cityIdData[i].areaName
                }
            }
            this.ruleForm.areaId=""
            if(this.ruleForm.layer=="市"){
                this.getlowerLevelData()
            }else if(this.ruleForm.layer== "县" || this.ruleForm.layer== "合作社"){
                this.getareaIdData()
            }
        },
        getareaIdData(){
            var getAreaInfoPo={}
            var id;
            if(localStorage.getItem('layer')=='admin'){
                id=this.ruleForm.cityId.toString()==''?'0':this.ruleForm.cityId.toString()
                getAreaInfoPo={
                    provinceId:localStorage.getItem('provinceId'),//省id
                    cityId:localStorage.getItem('cityId'),//市id
                    areaId:localStorage.getItem('areaId'),
                    checkId : id != undefined ? id : 0
                }
            }else if(localStorage.getItem('layer')=='省'){
                id=this.ruleForm.cityId.toString()
                getAreaInfoPo={
                    provinceId:'0',
                    cityId:localStorage.getItem('cityId'),
                    areaId:localStorage.getItem('areaId'),
                    checkId : id != undefined ? id : 0
                }
                this.ruleForm.provinceId=localStorage.getItem('provinceId')
            }else if(localStorage.getItem('layer')=='市'){
                getAreaInfoPo={
                    provinceId:'0',
                    cityId:'0',
                    areaId:localStorage.getItem('areaId'),
                    checkId : localStorage.getItem("cityId"),
                }
                this.ruleForm.cityId=localStorage.getItem('cityId')
            }else if(localStorage.getItem('layer')=='县'){
                getAreaInfoPo={
                    provinceId:'0',
                    cityId:'0',
                    areaId:'0',
                    checkId : localStorage.getItem("cityId"),
                }
                this.areaDisabled=false
                if(this.title=='添加'){
                    this.areaDisabled=true
                    this.ruleForm.areaId=localStorage.getItem('areaId')
                    this.ruleForm.areaName=localStorage.getItem('areaName')
                    this.getlowerLevelData()
                }
            }
            AdministratorService.AreaInfoList(getAreaInfoPo)
            .then((response)=>{
                // console.log(response);
                this.areaIdData=response
            })
        },
        areaIdChange(val){
            for(var i=0;i<this.areaIdData.length;i++){
                if(this.areaIdData[i].areaCode==val){
                    this.ruleForm.areaName=this.areaIdData[i].areaName
                }
            }
            this.getlowerLevelData()
        },
        // 获取下级数组
        getlowerLevelData(){
            var getAreaInfoPo={}
            var id;
            if(this.ruleForm.layer=="admin"){
                getAreaInfoPo={
                    provinceId:0,
                    cityId:0,
                    areaId:0,
                    checkId:0,
                }
            }else if(this.ruleForm.layer=="省"){
                id=this.ruleForm.provinceId.toString()
                getAreaInfoPo={
                    provinceId:0,
                    cityId:0,
                    areaId:0,
                    checkId : id != undefined ? id : 0
                }
            }else if(this.ruleForm.layer=="市"){
                id=this.ruleForm.cityId.toString()
                getAreaInfoPo={
                    provinceId:0,
                    cityId:0,
                    areaId:0,
                    checkId : id != undefined ? id : 0
                }
            }else if(this.ruleForm.layer=="县"){
                id=this.ruleForm.areaId.toString()
                getAreaInfoPo={
                    provinceId:0,
                    cityId:0,
                    areaId:id != undefined ? id : 0,
                    checkId : id != undefined ? id : 0
                }
            }else if(this.ruleForm.layer=="合作社"){
                return
            }
            AdministratorService.AreaInfoList(getAreaInfoPo)
            .then((response)=>{
                // console.log(response);
                this.areasData=response
            })
        },
        // 下级数据变化
        changeVal(val){
            // console.log(val)
            var arr=[]
            for(var i=0;i<val.length;i++){
                for(var j=0;j<this.areasData.length;j++){
                    if(val[i]==this.areasData[j].areaName){
                        arr.push(this.areasData[j].areaCode)
                    }
                }
            }
            // console.log(arr)
            this.ruleForm.areaIds=arr
        },
        // 删除弹窗取消
        resetFormDel(){
            this.delDialog=false
            this.delId=""
        },
        // 删除弹窗确定
        submitFormDel(){
            var that=this
            if(that.isDel==1){//删除
                AdministratorService.removeAdminInfo(this.delId)
                .then((res)=>{
                    // console.log(res)
                    if(res){
                        that.$message({
                            type: 'success',
                            message: "提交成功!"
                        });
                        that.delDialog=false
                        that.delId=""
                        that.isDel=1
                        that.forList();
                    }else{
                        that.$message.error("操作失败!");
                    }

                })
            }else if(this.isDel==0){//重置密码
                AdministratorService.resetPassword(this.delId)
                .then((res)=>{
                    // console.log(res)
                    if(res){
                        that.$message({
                            type: 'success',
                            message: "提交成功!"
                        });
                        that.delDialog=false
                        that.delId=""
                        that.isDel=1
                        that.forList();
                    }else{
                        that.$message.error("操作失败!");
                    }
                })
            }
            
        },
        // 分页调用
        handleSizeChange(){
        }, 
        handleCurrentChange(val) {
            this.currentPage = val;
            this.forList();
        },
        close(){
            this.$store.state.systemList=''
            this.$store.state.list='centerBot'
        },
    },
    beforeDestroy(){

    },
}
</script>
<style lang="less">
@import '../../viewsStyle/system/manager.less';
</style>